import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initI18n } from './i18n';
import { languageFromPath } from './i18n/languages';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Load the language from the URL before the first render, so a visitor
// opening /fr/... never sees the English text flash first.
initI18n(languageFromPath(window.location.pathname)).finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
